import React from 'react';

export const Phone = ({ color }) => (
  <svg
    width="18"
    height="25"
    viewBox="0 0 18 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2770_3758)">
      <path
        d="M14.4002 1.27991H3.6002C2.27471 1.27991 1.2002 2.35442 1.2002 3.67991V20.4799C1.2002 21.8054 2.27471 22.8799 3.6002 22.8799H14.4002C15.7257 22.8799 16.8002 21.8054 16.8002 20.4799V3.67991C16.8002 2.35442 15.7257 1.27991 14.4002 1.27991Z"
        stroke={color ?? '#005EE0'}
        strokeWidth="2.4"
      />
      <path
        d="M11.9998 4.87988H5.9998C5.33706 4.87988 4.7998 5.41714 4.7998 6.07988V14.4799C4.7998 15.1426 5.33706 15.6799 5.9998 15.6799H11.9998C12.6625 15.6799 13.1998 15.1426 13.1998 14.4799V6.07988C13.1998 5.41714 12.6625 4.87988 11.9998 4.87988Z"
        stroke={color ?? '#005EE0'}
        strokeWidth="2.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.94279 19.8799C9.27879 19.8799 9.60039 19.7191 9.60039 19.2859C9.60039 18.8527 9.43359 18.6799 9.09879 18.6799C8.76279 18.6799 8.40039 18.8527 8.40039 19.2859C8.40039 19.7179 8.60799 19.8799 8.94279 19.8799Z"
        stroke={color ?? '#005EE0'}
        strokeWidth="1.2"
      />
    </g>
    <defs>
      <clipPath id="clip0_2770_3758">
        <rect
          width="18"
          height="24"
          fill="white"
          transform="translate(0 0.0799561)"
        />
      </clipPath>
    </defs>
  </svg>
);
